export default "__VITE_ASSET__Dh1eyfSt__"